<template>
  <Timeline class="timeline-default mt-5">
    <TimelineItem
      v-for="(event, index) in getTimeline"
      :key="index"
      :timestamp="event.timestamp && getTimeStamp(event.timestamp)"
      placement="top"
      :class="getClassOfMessage(event)">
      <div v-if="event.type === 'destination' && Array.isArray(event.message)">
        <h4 v-for="(city,index) in event.message" :key="index">
          <span> - {{city}}</span>
        </h4>
      </div>
      <h4 v-else v-html="event.message">
      </h4>
      <p v-if="event.label" v-html="event.label">
      </p>
      <p v-if="event.description">
        {{event.description}}
      </p>
    </TimelineItem>
  </Timeline>
</template>

<script>
import { formatCommentDate } from '@/lib/Date';

export default {
  props: {
    timelineEvents: {
      type: Array,
      default: () => [],
    },
    hideRejected: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      index: null
    }
  },
  computed: {
    getTimeline() {
      if(this.hideRejected){
        return this.timelineEvents.filter(tl => tl.title !== 'Rejected');
      }
      return this.timelineEvents;
    },
  },
  methods: {
    getClassOfMessage(event) {
      if (event.type === 'destination') {
        return 'dot-green';
      } else if(event.message === 'reported at') {
        return 'dot-blue';
      } else {
        return 'dot-purple';
      }
    },
    getTimeStamp(time) {
      return formatCommentDate(time);
    }
  },
};
</script>
<style lang="scss">
.image {
  width: 100px;
  height: 100px;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
  border: 1px solid lightgray;
  object-fit: contain;
}
</style>
